import { render, staticRenderFns } from "./main.vue?vue&type=template&id=5be1003e"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5be1003e')) {
      api.createRecord('5be1003e', component.options)
    } else {
      api.reload('5be1003e', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=5be1003e", function () {
      api.rerender('5be1003e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/tableResultCol/main.vue"
export default component.exports